import {appGlobals} from '@/shared/appGlobals'
import dayjs from 'dayjs'

export const calculateCacheExpiration = function() {
    return dayjs().add(appGlobals.cacheExpirationInMinutes, 'minute')
}

function isDateArrayContiguous(dateArray) {
    let difference = dateArray.length - 1
    let incrementalDate = dayjs(dateArray[0].calendar_date).add(difference, 'day')
    return incrementalDate.isSame(dayjs(dateArray[difference].calendar_date, 'day'))
}

function makeContiguousOutput(dateArray) {
    let arrayLength = dateArray.length
    let startDay = dayjs(dateArray[0].calendar_date)
    let endDay = dayjs(dateArray[arrayLength - 1].calendar_date)
    let linkText = ''
    if (1 < arrayLength) {
        linkText = (2 < arrayLength ? ' to ' : ' and ')
    }

    let dateString = startDay.format('MMM D')
    if (1 < arrayLength) {
        if (false == startDay.isSame(endDay, 'year')) {
            dateString += startDay.format(', YYYY')
        }
        dateString += linkText
        dateString += dayjs(dateArray[arrayLength - 1].calendar_date).format('MMM D')
    }
    dateString += endDay.format(', YYYY')

    return dateString
}

function makeDiscontiguousOutput(dateArray) {
    let arrayLength = dateArray.length
    if (2 == arrayLength) {
        return makeDiscontiguousPair(dateArray)
    }

    let compareDay = dayjs(dateArray[0].calendar_date)
    let day = null
    let dateString = ''
    for (let i = 0; i < arrayLength; ++i) {
        day = dayjs(dateArray[i].calendar_date)
        if (false == day.isSame(compareDay, 'year')) {
            dateString = dateString.substring(0, dateString.length - 2)
            dateString += compareDay.format(' YYYY, ')
        }
        dateString += day.format('MMM D')
        if (i < arrayLength - 1) {
            if (2 == arrayLength) {
                dateString += ' and '
            } else {
                dateString += ', '
            }
        }
        compareDay = day
    }
    dateString += day.format(' YYYY')

    return dateString
}

function makeDiscontiguousPair(dateArray) {
    let earlierDay = dayjs(dateArray[0].calendar_date)
    let laterDay = dayjs(dateArray[1].calendar_date)
    let dateString = earlierDay.format('MMM D')
    if (false == earlierDay.isSame(laterDay, 'year')) {
        dateString += earlierDay.format(', YYYY')
    }
    dateString += ' and ' + laterDay.format('MMM D, YYYY')

    return dateString
}

export const arrayOfDatesToString = function(dateArray) {
    if (0 == dateArray.length) {
        return ''
    }

    dateArray = dateArray.sort((date1, date2) => {
        return date1.calendar_date < date2.calendar_date ? -1 : 1
    })

    return isDateArrayContiguous(dateArray) ? makeContiguousOutput(dateArray) : makeDiscontiguousOutput(dateArray)
}

export const dateSort = function(dateA, dateB) {
    const dayjsA = dayjs(dateA.calendar_date)
    const dayjsB = dayjs(dateB.calendar_date)
    if (dayjsA.isBefore(dayjsB, 'day')) {
        return -1
    }
    return 1
}

export const makeTimeslotDisplayDateAndTime = function(timeslot) {
    const dummyDate = '1971-01-01 '
    const displayDate = dayjs(timeslot.date.calendar_date).format('MMMM D')
    const displayStartTime = dayjs(dummyDate + timeslot.start_time).format('h:mm A')
    const displayEndTime = dayjs(dummyDate + timeslot.end_time).format('h:mm A')
    return displayDate + ' ' + displayStartTime + ' to ' + displayEndTime
}